// src/components/cards/subcomponents/DetailBlock.tsx

import { Box, Stack, Typography } from "@mui/material";
import DetailItem from './DetailItem';
import React from 'react';

interface DetailBlockProps {
    title: string;
    icon?: React.ElementType;
    /** `indent`: a breakdown of the row above ("of which …"), shown nested and muted, outside the sum. */
    items?: { label: string; value: React.ReactNode; valueColor?: string; indent?: boolean }[];
    children?: React.ReactNode;
}

/** Titled group of label/value rows (or custom children). */
export const DetailBlock: React.FC<DetailBlockProps> = ({ title, icon: Icon, items, children }) => (
    <Stack spacing={0.25}>
        {title && (
            <Stack direction="row" spacing={0.75} alignItems="center" sx={{ mb: 0.5 }}>
                {Icon && <Icon sx={{ fontSize: 15, color: 'text.secondary' }} />}
                <Typography variant="overline" color="text.secondary" sx={{ lineHeight: 1.4 }}>
                    {title}
                </Typography>
            </Stack>
        )}
        {items
            ? items.map(({ indent, ...item }) =>
                  indent ? (
                      <Box key={item.label} sx={{ pl: 1.5 }}>
                          <DetailItem {...item} valueColor={item.valueColor ?? 'text.secondary'} />
                      </Box>
                  ) : (
                      <DetailItem key={item.label} {...item} />
                  )
              )
            : children}
    </Stack>
);
